import type { FC } from 'react';
import React from 'react';
import { Box, Card } from '@edreamsodigeo/prisma-design-system';

interface MapCardWrapperProps {
  handleClick: () => void;
  maxWidth?: string;
  dataTestId?: string;
  trackingClickRef?: React.MutableRefObject<HTMLDivElement | null>;
  hasBorderRadius?: boolean;
}

const MapCardWrapper: FC<MapCardWrapperProps> = ({
  handleClick,
  children,
  dataTestId,
  trackingClickRef,
  hasBorderRadius,
}) => (
  <Box ref={trackingClickRef} width="100%">
    <Box data-testid={dataTestId} width="100%">
      <Card.Base
        sx={{
          overflow: 'hidden',
          height: '100%',
          width: '100%',
          background: 'neutral.0',
          ...(hasBorderRadius ? {} : { borderRadius: '0px' }),
        }}
        onClick={handleClick}
        aria-label="card"
      >
        {children}
      </Card.Base>
    </Box>
  </Box>
);

export default MapCardWrapper;
